/**
 * Created by mauget on 1/23/16.
 */

import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import listService      from 'ListService.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';

import DesignerModel     from 'DesignerModel.js';
import BehaviorsPageView from 'form/BehaviorsPageView.js';

//=============================================================================
//
// Creates one Fabric.js-based page, given a factoryService parameter key.
// The factory parameter defines the  control appearance through its
// specified template. It defines the rectangle of the control via a width
// and height from the factory parameter.
//
// NOTE: pages all share a common set of model property values. E.g. change
// page width, and all pages of a a form change width. Perhaps, we can insure
// that by storing page properties as class (static) properties.
//
// -Lou Mauget, January 23, 2016
//
//=============================================================================
class BehaviorsPageFactory extends BaseVisualControlFactory {

    constructor () {
        super();
    }

    createView( factoryKey, pos ) {

        const attributes = this.createChildAttributes(  factoryKey, pos ) ;
        attributes.name = 'Page';
        attributes.width  = 700;
        attributes.height = 900;


        let behaviorModel = listService.behaviorPage;
        if (!behaviorModel) {
            behaviorModel = new DesignerModel(attributes);
            listService.behaviorPage = behaviorModel;
        }


        return new BehaviorsPageView({
            model: behaviorModel, el: $(constants.FORM_ID),
            pos: undefined, factoryKey: factoryKey, id: sequenceService.nextDomId()
        });

        /*
        let behaviorsPageView;

        behaviorsPageView = listService.BehaviorsPage;

        if (!behaviorsPageView) {

            behaviorsPageView = new BehaviorsPageView({
                model: new DesignerModel(attributes), el: $(constants.FORM_ID),
                pos: undefined, factoryKey: factoryKey, id: sequenceService.nextDomId()
            });

            listService.BehaviorsPage = behaviorsPageView;
        }

        return behaviorsPageView;
        */
    }

}

const behaviorsPageFactory = new BehaviorsPageFactory();
export default behaviorsPageFactory;
